import { type UpdateAlertDialogProps } from './update-alert-dialog'

type UseUpdateAlertDialogParams = Pick<UpdateAlertDialogProps, 'onClose'>

export const useUpdateAlertDialog = ({ onClose }: UseUpdateAlertDialogParams) => {
  const handleOpenChange = (open: boolean) => {
    if (!open) {
      onClose()
    }
  }

  return { handleOpenChange }

  return {}
}
